import { render, staticRenderFns } from "./PersonnelEvaluation.vue?vue&type=template&id=1bbaddf9"
import script from "./PersonnelEvaluation.vue?vue&type=script&lang=js"
export * from "./PersonnelEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports